export default function AdminHeader() {
  const user = JSON.parse(localStorage.getItem("userData") || "{}");

  return (
    <div className="p-4 border-b border-gray-700 bg-gray-850 flex justify-between items-center">
      <h2 className="text-xl font-bold">
        Welcome Mr. <span className="text-yellow-500">{user.name || "MOKU"}</span>,  
        President of <span className="text-yellow-500">WAR FC</span>
      </h2>
    </div>
  );
}
